export default __webpack_public_path__ + "static/media/internal-msg-12-green.037b26cc.svg";